import React from 'react';
import ContentLoader from 'react-content-loader'

import { getLoaderColors } from '../../utils/theme';

import ThemeContext from '../../context/ThemeContext';

const Placeholder = props => {
    return (
        <ThemeContext.Consumer>
            {
                ({ theme }) => (
                    <div className="project-generic-item placeholder">
                        <div className="project-generic-item-grid">
                            <ContentLoader width="247" height="288" animate={!props.static} primaryColor={getLoaderColors(theme).primary} secondaryColor={getLoaderColors(theme).secondary}>
                                <rect x="0" y="0" rx="4" ry="4" width="247" height="165" />
                                <rect x="20" y="195" rx="4" ry="4" width="160" height="8" />
                                <rect x="20" y="215" rx="4" ry="4" width="180" height="6" />
                                <rect x="20" y="235" rx="4" ry="4" width="120" height="6" />
                            </ContentLoader>
                        </div>

                        <div className="project-generic-item-list">
                            <ContentLoader width="297" height="72" animate={!props.static} primaryColor={getLoaderColors(theme).primary} secondaryColor={getLoaderColors(theme).secondary}>
                                <rect x="0" y="0" rx="4" ry="4" width="117" height="72" />
                                <rect x="137" y="20" rx="4" ry="4" width="160" height="8" />
                                <rect x="137" y="46" rx="4" ry="4" width="100" height="6" />
                                <rect x="257" y="46" rx="4" ry="4" width="40" height="6" />
                            </ContentLoader>
                        </div>
                    </div>
                )
            }
        </ThemeContext.Consumer>
    )
}

export default Placeholder;
